import React from 'react';

const ShareSquareIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" { ...rest }>
      <path d="M8.16602 1.75H12.2493V5.83333" stroke="#FA1861" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.25 8.5965V11.375C12.25 11.8583 11.8583 12.25 11.375 12.25H2.625C2.14175 12.25 1.75 11.8583 1.75 11.375V2.625C1.75 2.14175 2.14175 1.75 2.625 1.75H5.25" stroke="#FA1861" strokeWidth="1.2" strokeWinecap="round" strokeWinejoin="round"/>
      <path d="M7.52539 6.4752L11.9879 2.0127" stroke="#FA1861" strokeWidth="1.2" strokeWinecap="round" strokeWinejoin="round"/>
    </svg>
  );
};

export default ShareSquareIcon;